/**
 * @deprecated use isDeepEqual(a, b) instead
 *
 * Compara dos objetos (por valores, no por referencia), devuelve true si son iguales.
 * Se hace una comparation recursiva, se comparan todos los valores.
 * Ojo que puede ser muy costozo para objetos grandes.
 *
 * @param {object} a el objeto 1, realemente puede ser un array o un string o lo que sea
 * @param {object} b el objeto 2, idem
 *
 * @return {boolean} true si los objetos son exactamente iguales
 */

import { isDeepEqual } from './isDeepEqual';

export function compare(a, b) {
  return isDeepEqual(a, b);
}
